import { APIS } from 'scbk-banca/constants/apiPaths';
import HolBncInqGetAccountDetail from './kr/HolBncInqGetAccountDetail.json';
import HolBncInqGetAccountServiceInfo from './kr/HolBncInqGetAccountServiceInfo.json';
import HolBncInqListAccountRateOfReturn from './kr/HolBncInqListAccountRateOfReturn.json';
import HolBncInqListAccountTransaction from './kr/HolBncInqListAccountTransaction.json';
import settingsCodeList from './kr/settingsCodeList.json';

export const MockConfig = {
    ['/auth/settings/code/list']: () => settingsCodeList,

    [APIS.holdings.banca.inquiry.getAccountDetail]: () => HolBncInqGetAccountDetail,

    [APIS.holdings.banca.inquiry.getAccountServiceInfo]: () => HolBncInqGetAccountServiceInfo,

    [APIS.holdings.banca.inquiry.listAccountTransaction]: () => HolBncInqListAccountTransaction,

    [APIS.holdings.banca.inquiry.listAccountRateOfReturn]: () => HolBncInqListAccountRateOfReturn,
};
